import { prepareMoviesData } from '../../utils/prepareMoviesData';
import { getMoviesJsonForEnUs } from '../../utils/getMoviesJsonForEnUs';
import japaneseMoviesJSON from './japaneseMovies.data.json';
import adriftInTokyoImageUrl from './assets/adrift-in-tokyo.jpg';
import battleRoyaleImageUrl from './assets/battle-royale.jpg';
import darkWaterImageUrl from './assets/dark-water.jpg';
import departuresImageUrl from './assets/departures.jpg';
import driveMyCarImageUrl from './assets/drive-my-car.jpg';
import ringuImageUrl from './assets/ringu.jpg';
import shopliftersImageUrl from './assets/shoplifters.jpg';
import spiritedAwayImageUrl from './assets/spirited-away.jpg';
import spiritedAwayPreviewUrl from './assets/spirited-away-preview.png';
import stillWalkingImageUrl from './assets/still-walking.jpg';
import sweetBeanImageUrl from './assets/sweet-bean.jpg';
import tampopoImageUrl from './assets/tampopo.jpg';
import tokyoGodfathersImageUrl from './assets/tokyo-godfathers.jpg';
import tokyoStoryImageUrl from './assets/tokyo-story.jpg';
import tokyoStoryPreviewUrl from './assets/tokyo-story-preview.png';
import yourEyesTellImageUrl from './assets/your-eyes-tell.jpg';
import yourNameImageUrl from './assets/your-name.jpg';

const images = {
  posters: {
    'adrift-in-tokyo-2007': adriftInTokyoImageUrl,
    'battle-royale-2000': battleRoyaleImageUrl,
    'dark-water-2002': darkWaterImageUrl,
    'departures-2008': departuresImageUrl,
    'drive-my-car-2021': driveMyCarImageUrl,
    'ringu-1998': ringuImageUrl,
    'shoplifters-2018': shopliftersImageUrl,
    'spirited-away-2001': spiritedAwayImageUrl,
    'still-walking-2008': stillWalkingImageUrl,
    'sweet-bean-2015': sweetBeanImageUrl,
    'tampopo-1985': tampopoImageUrl,
    'tokyo-godfathers-2003': tokyoGodfathersImageUrl,
    'tokyo-story-1953': tokyoStoryImageUrl,
    'your-eyes-tell-2020': yourEyesTellImageUrl,
    'your-name-2016': yourNameImageUrl,
  },
  previews: {
    'spirited-away-2001': spiritedAwayPreviewUrl,
    'tokyo-story-1953': tokyoStoryPreviewUrl,
  },
};

export const japaneseMovies = prepareMoviesData(japaneseMoviesJSON, images);

export const japaneseMoviesForEnUs = prepareMoviesData(
  getMoviesJsonForEnUs(japaneseMoviesJSON),
  images,
);
